module.exports = __webpack_public_path__ + "img/case32.7818febb.png";